"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactComponents = require("@ui-propulsion/react-components");
var _util = require("../../../util");
var _details = _interopRequireDefault(require("./details"));
(function () {
  if (typeof document === "undefined") {
    return;
  }
  var styles = ".center-flex, .checkmark-income {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.income-accordion, .pf-income-details-accordion {\n  border-left: 6px solid #58B0DD;\n}\n\n.pf-income-details-accordion {\n  box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.2);\n}\n.pf-income-details-accordion .pf-texts, .pf-income-details-accordion .details__item {\n  color: #113b5e;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n}\n@media (min-width: 320px) {\n  .pf-income-details-accordion {\n    font-family: \"Neue Haas Grotesk Text Regular\", \"Helvetica Neue\", helvetica, arial, sans-serif;\n    font-size: 16px;\n    line-height: 24px;\n  }\n}\n@media (min-width: 1024px) {\n  .pf-income-details-accordion {\n    font-size: 18px;\n    line-height: 28px;\n  }\n}\n.pf-income-details-accordion div {\n  background-color: #F6F9F9;\n}\n.pf-income-details-accordion div.pds-accordion__section-body {\n  padding: 0;\n}\n.pf-income-details-accordion__header {\n  font-weight: 700;\n  font-size: 14px;\n  color: #113B5E;\n  background-color: #F6F9F9;\n  line-height: 16px;\n}\n.pf-income-details-accordion__header:hover {\n  background-color: #F6F9F9;\n}\n.pf-income-details-accordion .pds-accordion__section-header {\n  padding-top: 16px;\n  padding-bottom: 16px;\n  padding-left: 16px;\n  background-color: #F6F9F9;\n}\n.pf-income-details-accordion .pds-accordion__section-header:hover {\n  background-color: #F6F9F9;\n}\n\n.details__list {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  margin: 0 0 0 20px;\n  padding: 0;\n}\n.details__item {\n  display: flex;\n  margin-bottom: 20px;\n  margin-right: 24px;\n}\n@media (min-width: 768px) {\n  .details__item {\n    margin-bottom: 20px;\n  }\n}\n.details__item:first-of-type {\n  margin-bottom: 15px;\n}\n.details__text-wrap {\n  font-size: 12px;\n}\n.details__text-wrap--first-line {\n  margin: 0;\n}\n.details__text-wrap--description.pf-texts, .details__text-wrap--description.details__item {\n  margin-top: 15px;\n  margin-bottom: 9px;\n}\n@media (min-width: 768px) {\n  .details__text-wrap--description.pf-texts, .details__text-wrap--description.details__item {\n    margin-bottom: 0;\n  }\n}\n@media (min-width: 768px) {\n  .details__item {\n    margin-right: 16px;\n    margin-bottom: 20px;\n  }\n  .details__item:nth-of-type(3) {\n    align-items: center;\n  }\n  .details__item:nth-of-type(4) {\n    align-items: center;\n  }\n  .details__item:nth-of-type(5) {\n    margin-bottom: 15px;\n  }\n}\n\n.details__text-wrap--first-line > p {\n  margin: 0;\n  font-weight: 400;\n}\n\n.checkmark-income {\n  border-radius: 50%;\n  background-color: #11742f;\n  min-width: 24px;\n  width: 24px;\n  height: 24px;\n  margin-inline-end: 14px;\n}\n.checkmark-income svg {\n  display: flex;\n}";
  var fileName = "details__styles_f50c6140-92e3-46e6-a962-95d53ca103c8";
  var element = document.querySelector("style[data-sass-component='details__styles_f50c6140-92e3-46e6-a962-95d53ca103c8']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var BLOCK_CLASS = 'pf-income-details-accordion';
var IncomeDetails = function IncomeDetails(_ref) {
  var className = _ref.className,
    details = _ref.details,
    header = _ref.header;
  return /*#__PURE__*/_react.default.createElement("section", {
    className: (0, _util.addClassNames)(className, BLOCK_CLASS)
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.App, null, /*#__PURE__*/_react.default.createElement(_reactComponents.Accordion, {
    data: [{
      id: 'accordion-wrapper',
      header: /*#__PURE__*/_react.default.createElement("span", {
        className: "".concat(BLOCK_CLASS, "__header")
      }, header),
      details: /*#__PURE__*/_react.default.createElement(_details.default, {
        details: details
      })
    }]
  })));
};
IncomeDetails.propTypes = {
  className: _propTypes.default.string,
  header: _propTypes.default.string,
  details: _propTypes.default.arrayOf(_propTypes.default.shape({
    icon: _propTypes.default.string,
    title: _propTypes.default.string,
    text: _propTypes.default.arrayOf(_propTypes.default.string)
  }))
};
IncomeDetails.defaultProps = {
  className: 'default-class-name',
  header: 'What can I include as total annual income?',
  details: [{
    text: ['Some examples of income include the following:']
  }, {
    icon: 'checkmark-income',
    title: 'Income from employment,',
    text: [' including full-time, part-time, freelance, or seasonal jobs']
  }, {
    icon: 'checkmark-income',
    title: 'Self-employment,',
    text: [' including any business dividends or rental income']
  }, {
    icon: 'checkmark-income',
    title: 'Non-taxable-income,',
    text: [' if included, should be increased by 25%']
  }, {
    icon: 'checkmark-income',
    title: 'Any other income such as retirement, ',
    text: [' social security, or public assistance', 'Only include alimony, child support, or separate maintenance if you wish for us to consider it as a source of loan repayment.']
  }]
};
var _default = IncomeDetails;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');